import { AfterViewInit, Component, EventEmitter, ElementRef, Input, OnInit, Output, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { IonSlides, ModalController, NavController, Platform } from '@ionic/angular';
import { UiService } from 'src/app/admin/service/ui.service';
import { DataProduct, ResProduct } from 'src/app/generales/login/pages/perfil/interfaces-perfil/interfacesPerfil';
import { BalanceService } from 'src/app/generales/services/balance.service';
import { CartServiceService } from 'src/app/generales/services/cart-service.service';
import { StorageService } from 'src/app/generales/services/storage.service';
import { ToastService } from 'src/app/generales/services/toast.service';
import { ProductService } from 'src/app/market-place/services/product.service';
import { environment } from 'src/environments/environment';
import { ZoomImgComponent } from '../zoom-img/zoom-img.component';
import { PromDatesService } from 'src/app/services/prom-dates.service';
// import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';

@Component({
  selector: 'Amarillas-detail-product',
  templateUrl: './detail-product.component.html',
  styleUrls: ['./detail-product.component.scss'],
})
export class DetailProductComponent implements OnInit, AfterViewInit {
  @ViewChild('productMedia') productMedia: IonSlides;
  @ViewChild('zoomIn') zoomIn: ElementRef<HTMLImageElement>;
  @ViewChild('zoomInContainer') zoomInContainer: ElementRef<HTMLImageElement>;
  @ViewChildren('rect') rect: QueryList<ElementRef<HTMLDivElement>>;
  @Output() onZoomEmitter = new EventEmitter();
  @Output() outZoomEmitter = new EventEmitter();
  @Input() idProduct = undefined;

  public dataProduct: DataProduct;
  public carritoIcon: string = './assets/img/icons/addCarrito.svg';
  public irCarritoIcon: string = './assets/img/icons/iracarrito.svg';
  public url: string = environment.url;
  public cantidad:number = 0;
  public contador = undefined;
  public store: any = undefined;
  public user: any = undefined;
  public currency: any = undefined;
  public selectedImg = '';
  public image = '';
  public haveVideo = undefined;
  public bookmark = 'bookmark-outline';
  public assetsUrl = './assets/img/icons/'
  public like = '';
  public likes = 0;
  public promValid = false;
  public curDate = undefined;
  public startDate = undefined;
  public endDate = undefined;
  public slideOpt = {
    loop: true,
    speed: 400,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  }


  constructor(
    private productService: ProductService,
    private modalController: ModalController,
    private storageService: StorageService,
    private cartService: CartServiceService,
    private toastService:ToastService,
    private navCtrl: NavController,
    private balanceService: BalanceService,
    private renderer: Renderer2,
    private uiSv: UiService,
    // private socialSharing: SocialSharing,
    private platform: Platform,
    private dates: PromDatesService
  ) {}

  ngOnInit() {
    this.balanceService.currency.subscribe(currency => {
      this.currency = currency;
    });
    this.curDate = new Date();
  }

  ngAfterViewInit(): void {
    setTimeout(async () => {
      const change = await this.balanceService.setCurrency();
      this.currency = change;
      const token = await this.storageService.get('token');
      this.productService.getProduct(this.idProduct, token).subscribe((res:ResProduct) => {
        this.dataProduct = res.data.data;
        if(this.dataProduct.store.end){
          const end = new Date(this.dataProduct.store.end);
          end.setMonth(end.getMonth() + 1);
          const actualDate = new Date();
          if(actualDate > end ){
            this.dataProduct.store.defeated = true;
          }else{
            this.dataProduct.store.defeated = false;
          }
        }else{
          this.dataProduct.store.id_plan = null;
        }
        
        this.likes = this.dataProduct.meta.likes_count;
        if(this.dataProduct?.meta?.favorite){
          this.bookmark = 'bookmark';
        }
        if(this.dataProduct.meta.isLikes){
          this.like = `${this.assetsUrl}thumbs-up-sharp.svg`;
        }else{
          this.like = `${this.assetsUrl}thumbs-up-outline.svg`;
        }
        this.haveVideo = this.dataProduct.video && !this.dataProduct.video.includes('https://null');
        this.selectedImg = this.dataProduct.media[0].img;
        this.store = this.dataProduct.store;
        this.user = this.dataProduct.user;
        this.findValue(this.idProduct);
        console.log('this.dataproduct :>> ', this.dataProduct);
        if (this.dataProduct.presentation==='null') {
          this.dataProduct.presentation=''
        }
        this.curDate = new Date()
        console.log(`curDate: ${this.curDate}`);
        this.promValid = this.dates.validProm(this.dataProduct.promotionalInit, this.dataProduct.promotionalEnd, this.curDate);
      });
    })
  }

  async stopSlides(stop){
    if(stop) await this.productMedia.stopAutoplay();
    else await this.productMedia.startAutoplay();
  }

  setImg(img, index){
    this.productMedia.slideTo(index, 400);
    this.selectedImg = img;
  }

  async slideTo(direction){
    await direction ? this.productMedia.slideNext() : this.productMedia.slidePrev()
    const index = await this.productMedia.getActiveIndex();
    const imgData = this.dataProduct.media[index];
    if(imgData){
      this.selectedImg = imgData.img;
    }
  }

  async closeModal(){
    await this.modalController.dismiss();
  }

  async findValue(id) {
    const dataCart = await this.storageService.get('cart');
    if (!dataCart) return;
    dataCart.forEach((cart) => {
      for(const key of Object.keys(cart)){
        const data = cart[key]?.productos.find(
          (savedCart) => savedCart.idProduct === id
        );
        if(data){
          this.cantidad = data?.cantidad || 0;
          
          this.contador = 0;
          return
        }
      }
    });
  }

  countProducts(op){
    if (op != 'sum' && this.cantidad === 0) {
      return false
    }

    if (op == 'sum') {
      this.cantidad++;
    } else {
      if (this.cantidad) this.cantidad--;
    }

    const contador = localStorage.getItem('contador');
    if (contador) {
      let newData = Number(contador);
      if (op != 'sum') newData--;
      else newData++;
      localStorage.setItem('contador', String(newData));
    } else {
      localStorage.setItem('contador', '1');
    }

  }

  async addToCart(
    idProduct: any,
    storeId: any,
    price: number,
    media,
    description,
    store,
    user,
    title
  ) {
    
    let oldStorage: any = await this.storageService.get('cart');
    let typeProduct = user ? 'user' : 'store';
    
    const actual = (await this.findProduct(
      oldStorage,
      user ? user.id : store.id,
      typeProduct
    )) ?? {
      store,
      user,
    };
    const existStore = actual[typeProduct];
    if (existStore) {
      if (!existStore.productos) existStore.productos = [];
      const id = existStore.productos.find(
        (cartProduct) => cartProduct.idProduct === idProduct
      );
      if (!id) {
        existStore.productos.push({
          idProduct,
          storeId,
          cantidad: this.cantidad,
          price,
          media,
          description,
          title,
        });
      }
    } 
    if (!oldStorage) {
      await this.storageService.set('cart', [
        {
          store,
          user,
        },
      ]);
      oldStorage = await this.storageService.get('cart');
    }
    // paso 1) Busco el storage del usuario

    // Paso 2) buscar el producto que se esta modificando
    const actualProduct = actual[typeProduct].productos.find(
      (product) => product.idProduct === idProduct
    ); //producto
    actualProduct.price = price;
    actualProduct.cantidad = this.cantidad;
    
    const storeEditing: any = actual[typeProduct];
    const indexEditing = storeEditing.productos.filter(
      (cartPr) => cartPr.idProduct !== idProduct
    );
    actual[typeProduct].productos = [...indexEditing, actualProduct];
    this.updateStorage(oldStorage, typeProduct, actual);
  }

  async updateStorage(oldStorage, typeProduct, actual) {
    const newStorage = oldStorage.filter((cart) => {
      if (!cart[typeProduct]) return oldStorage;
      return cart[typeProduct].id !== actual[typeProduct].id;
    });
    newStorage.push(actual);
    await this.storageService.set('cart', newStorage);
    this.cartService.setLength();
    this.toastService.show('SENTENSES.PRODUCTO_AGREGADO_AL_CARRITO');
    // this.modalController.dismiss(this.cantidad, 'saveQuantity')
  }

  findProduct(storage, userId, type) {
    if (!storage) return null;
    return new Promise((resolve, reject) => {
      resolve(
        storage.find((user) => {
          if (!user[type]) {
            return null;
          }
          return user[type].id === userId;
        })
      );
    });
  }

  seeVideo(){
    if(!this.dataProduct.video.includes('https')){
      this.dataProduct.video = `https://${this.dataProduct.video}`;
    }else if(!this.haveVideo){
      return false;
    }
    window.open(this.dataProduct.video, '_blank')
  }

  async goTo(url){
    await this.navCtrl.navigateRoot(url);
  }

  async openImg(img){
    if(document.body.offsetWidth < 769){
      const data = { img }
      await this.uiSv.createModal(ZoomImgComponent, { data }, 'zoomContainer');
    }
  }

  async goToStore(){
    await this.navCtrl.navigateRoot(`/market-place/store/${this.dataProduct.storeId}/1`,
    {
      queryParams:
      {
        name: this.dataProduct.store.business_name.replace(/ /g, '-')
      }
    });
  }

  onZoom(ev, element, index: number){
    //Medidas del contenedor
    this.stopSlides(true);
    const rect = this.rect.get(index).nativeElement;
    const w1 = element.el.offsetWidth;
    const h1 = element.el.offsetHeight;
    
    //Posicion del mouse
    let x = ev.offsetX;
    let y = ev.offsetY;
    //Medidas del rectangulo
    let w2 = rect.offsetWidth / 2;
    let h2 = rect.offsetHeight / 2;
    let xx = x - w2;
    let yy = y - h2;
    if(x < w2){
      x = w2;
      xx = 0;
    }

    if(y < h2){
      y = h2;
      yy = 0;
    }

    if(x > w1 - w2){
      x = w1 - w2;
      xx = x - w2;
    }

    if(y > h1 - h2){
      y = h1 - h2;
      yy = y - h2;
    }
    if(document.body.offsetWidth > 769){
      this.renderer.setStyle(rect, 'left', `${x}px`);
      this.renderer.setStyle(rect, 'top', `${y}px`);
      this.renderer.setStyle(rect, 'opacity', '1');
      const obj: any = {
        ev,
        img: this.dataProduct.media[index].img,
        w2,
        h2,
        xx,
        yy
      }
      this.setOnZoom(obj);
      // this.onZoomEmitter.emit(obj);
    }
  }

  offZoom(index){
    this.stopSlides(false);
    const rect = this.rect.get(index).nativeElement;
    this.renderer.setStyle(rect, 'opacity', '0');
    this.image = '';
    this.renderer.setStyle(this.zoomInContainer.nativeElement, 'display', `none`);
  }

  setOnZoom(data){
    let ratio = 8;
    let x = 1.90;
    let y = 1.25;
    let scale = 2.5;
    // if(document.body.offsetWidth <= 1280){
    //   ratio = 5;
    //   x = 2.80;
    // }
    // if(document.body.offsetWidth <= 1024){
    //   scale = 2;
    //   ratio = 4;
    //   x = 4.75;
    //   y = 2.25
    // }
    const img = data.img;
    this.image = img;
    this.renderer.setStyle(this.zoomIn.nativeElement, 'transform', `scale(${scale})`);
    this.renderer.setStyle(this.zoomIn.nativeElement, 'transform-origin', `${data.xx * x}px ${data.yy * y}px`);
    this.renderer.setStyle(this.zoomInContainer.nativeElement, 'height', `${data.h2 * ratio}px`);
    this.renderer.setStyle(this.zoomInContainer.nativeElement, 'width', `${data.w2 * ratio}px`);
    this.renderer.setStyle(this.zoomInContainer.nativeElement, 'display', `block`);
  }

  async shareProduct(){
    if(this.platform.is('capacitor')){
      // this.socialSharing.share(
      //   this.dataProduct.description, 
      //   this.dataProduct?.name,
      //   null,
      //   window.location.href
      // )
      //   .then((res) => {
      //     console.log(res);
      //   })
      //   .catch(err => {
      //     console.error(err);
      //   })
    }else{
      const data: ShareData = {
        url: window.location.href,
        title: this.dataProduct?.name,
        text: `${this.dataProduct.description}
          ${this.dataProduct.price}`
        }
      await navigator.share(data)
    }
  }

  async saveFavorite(type){
    const res: any = await this.productService.saveFavorite(
      {productId: this.dataProduct.id}, type
    );

    if(res.status){
      if(type === 'favorite'){
        this.bookmark === 'bookmark' 
          ? this.bookmark = 'bookmark-outline' 
          : this.bookmark = 'bookmark';
      }else{
        this.like === `${this.assetsUrl}thumbs-up-sharp.svg`
          ? this.like = `${this.assetsUrl}thumbs-up-outline.svg` 
          : this.like = `${this.assetsUrl}thumbs-up-sharp.svg`;
        res.data ? this.likes++ : this.likes--;
      }
    }
  }
}
